import React from "react";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import TestimonialModal from "../TestimonialModal";
import RateReviewIcon from "@mui/icons-material/RateReview";
import { Fab } from "@mui/material";
import { useState, useEffect } from "react";

function PageWrapper({ children, hideNav }) {
  const [testimonialModalOpen, setTestimonialModalOpen] = useState(false);

  useEffect(() => {
    const handleOpen = () => setTestimonialModalOpen(true);
    window.addEventListener('openTestimonial', handleOpen);
    return () => window.removeEventListener('openTestimonial', handleOpen);
  }, []);

  return (
    <>
      <div className="px-4 md:px-8 pb-6 sm:pb-8">
        {!hideNav && <Navbar />}
        <div className={!hideNav ? "pt-28 sm:pt-32 md:pt-36" : "pt-4 sm:pt-6"}>{children}</div>
      </div>
      
      <button
        onClick={() => setTestimonialModalOpen(true)}
        className={`fixed bottom-6 right-6 z-[1000] flex items-center bg-[#a16207] text-white rounded-full shadow-[0_4px_14px_0_rgba(161,98,7,0.39)] hover:shadow-[0_6px_20px_0_rgba(161,98,7,0.5)] active:scale-95 transition-all duration-500 group overflow-hidden h-[56px] border-none cursor-pointer ${
          testimonialModalOpen ? "w-[190px]" : "w-[56px] sm:hover:w-[190px] active:w-[190px]"
        }`}
        aria-label="Add Testimonial"
      >
        <div className="flex items-center justify-center min-w-[56px] h-full">
          <RateReviewIcon sx={{ fontSize: 24 }} />
        </div>
        <span className={`whitespace-nowrap transition-all duration-500 font-bold text-sm pr-6 ${
          testimonialModalOpen ? "opacity-100" : "opacity-0 sm:group-hover:opacity-100 group-active:opacity-100"
        }`}>
          Add Testimonial
        </span>
      </button>

      <TestimonialModal
        open={testimonialModalOpen}
        onClose={() => setTestimonialModalOpen(false)}
      />
      
      <Footer />
    </>
  );
}

export default PageWrapper;
